import { connect } from 'react-redux';
import Component from './component';
import setOpenNotificationDrawerAction from '../../actions/notificationdrawer/set';

const mapStateToProps = (state) => ({
  notificationdraweropen: state.notificationdrawer.get('open'),
  notifications: state.notifications.get('data'),
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenNotificationDrawer: async (e, isOpen) => {
    e.preventDefault();
    await dispatch(await setOpenNotificationDrawerAction(isOpen));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
